/**
 * The name of the planting wishlist element category.
 */
export const PLANTING_ELEMENTS_CATEGORY = "Planting elements";
